import { TableCell, TableRow } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  rowCell: {
    cursor: "pointer !important",
    background: theme.palette.primary.blue,
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
  },
  rowCellOdd: {
    cursor: "pointer !important",
    background: "white",
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
  },
  image: {
    maxWidth: "100px",
    height: "auto",
  },
  tableCell: {
    color: theme.palette.primary.copy,
  },
}));

export default function RsvpCell({ columns, element, index, setTableData }) {
  const classes = useStyles();

  return (
    <>
      <TableRow
        hover
        className={index % 2 ? classes.rowCell : classes.rowCellOdd}
        key={index}
      >
        {columns.map((column, elementIndex) => (
          <TableCell
            align="left"
            key={elementIndex}
            className={classes.tableCell}
          >
            {column.label === "RSVP Date" ||
            column.label === "Guests" ||
            column.label === "Guests Attended" ||
            column.label === "Attendance Date"
              ? element[column.propName]
              : element[column.propName.split(".")[0]][
                  column.propName.split(".")[1]
                ]}
          </TableCell>
        ))}
      </TableRow>
    </>
  );
}
